import { z } from 'zod';

// A visitor's choice about Lyrmo's own insights: allowed, or only what the site needs to work.

/** The cookie that keeps the choice, read by the site and by the API. */
export const CONSENT_COOKIE = 'ly_consent';

export const CONSENT_CHOICES = ['insights', 'necessary'] as const;
export type ConsentChoice = (typeof CONSENT_CHOICES)[number];

/** How long a choice stands before it's asked again: six months, in seconds. */
export const CONSENT_MAX_AGE_S = 182 * 24 * 60 * 60;

/** A choice just made, counted for the admin's insights as no one's. */
export const ConsentRequestSchema = z.object({ choice: z.enum(CONSENT_CHOICES) });
export type ConsentRequest = z.infer<typeof ConsentRequestSchema>;
